// Based on https://github.com/LogRocket/logrocket-fuzzy-search-sanitizer

import { some } from '@sama/micro-dash';
import { forOwn, keys } from 'lodash';

const headersToRedact = [
  'Authorization',
  'X-Kaguya-Token',
  'Cookie',
  'Set-Cookie',
];
const bodyFieldsToRedact = ['access_token', 'signed_urls'];
const stripQueryParamsRegex =
  /(https?:\/\/[^\/]*(assets|samahub3|storage)[^\/]*(amazonaws\.com|googleapis\.com|samasource\.org|sama\.com).*)|https?:\/\/[^\/]*(windows.net|azureedge.net).*/;

export function sanitizeUrl(url: string) {
  // fix me if you change this code
  // eslint-disable-next-line no-param-reassign -- fix me!
  url = url.replace(/access_key=([^&]*)/, 'access_key=REDACTED');

  if (url.match(stripQueryParamsRegex)) {
    // fix me if you change this code
    // eslint-disable-next-line no-param-reassign -- fix me!
    url = url.replace(/\?.*/, '?REDACTED');
  }

  return url;
}

export function sanitizeHeaders(headers: StrictRecord<string, any>) {
  forOwn(headers, (_, header) => {
    if (
      some(
        headersToRedact,
        (headerToRedact) =>
          header.toLowerCase() === headerToRedact.toLowerCase(),
      )
    ) {
      headers[header] = 'REDACTED';
    }
  });
  return headers;
}

export function sanitizeBody(
  body = '',
  headers: StrictRecord<string, string | undefined> = {},
) {
  const contentTypeKey = keys(headers).find(
    (key) => key.toLowerCase() === 'content-type',
  );
  if (contentTypeKey && headers[contentTypeKey]?.includes('application/json')) {
    // fix me if you change this code
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    const parsedResponse = JSON.parse(body ?? '');
    redactBody(parsedResponse);
    // fix me if you change this code
    // eslint-disable-next-line no-param-reassign -- fix me!
    body = JSON.stringify(parsedResponse);
  }
  return body;
}

function redactBody(body: StrictRecord<string, any> = {}) {
  if (Array.isArray(body)) {
    body.forEach((item) => redactBody(item));
  } else {
    forOwn(body, (value, key) => {
      if (typeof value === 'object') {
        redactBody(value);
      }

      const shouldRedact = bodyFieldsToRedact.some(
        (field) => key.toLowerCase() === field.toLowerCase(),
      );

      if (shouldRedact) {
        body[key] = 'REDACTED';
      }
    });
  }
}
